<template>
    <div class="row">
        <div class="col-md-9">
            <select v-model="step" class="form-control mb-1 w-auto" @change="getResults">
                <option value="day">Day</option>
                <option value="month">Month</option>
                <option value="quarter">Quarter</option>
                <option value="year">Year</option>
            </select>
            <LineChartGenerator
                v-if="loaded"
                :chart-options="chartOptions"
                :chart-data="chartData"
            />
        </div>
        <div class="col-md">
            <div>Data</div>
            <select v-model="dataFilterType" class="form-control mb-3 text-capitalize" @change="changeDataFilters()">
                <option value="global">Global</option>
                <option value="product">Product</option>
                <option value="category">Category</option>
                <option value="location">{{config.location}}</option>
            </select>
            <div v-if="dataFilterType == 'product'">
                <div>Products to compare</div>
                <select v-model="dataSelectedProducts" class="form-control mb-3" multiple @change="getResults">
                    <option value="all">All</option>
                    <option v-for="product in dataProducts" :key="product.id" :value="product.id">{{product.nameWithVariation}}</option>
                </select>
            </div>
            <div v-if="dataFilterType == 'category'">
                <div>Categories to compare</div>
                <select v-model="dataSelectedCategories" class="form-control mb-3" multiple @change="getResults">
                    <option value="all">All</option>
                    <option v-for="category in dataCategories" :key="category.id" :value="category.id">{{category.name}}</option>
                </select>
            </div>
            <div v-if="dataFilterType == 'location'">
                <div><span class="text-capitalize">{{config.location}}</span> to compare</div>
                <select v-model="dataSelectedLocations" class="form-control mb-3" multiple @change="getResults">
                    <option value="all">All</option>
                    <option v-for="locationCode in dataLocations" :key="locationCode" :value="locationCode">{{location_list[locationCode]}}</option>
                </select>
            </div>
            <div>Data type</div>
            <select v-model="dataType" class="form-control mb-3" @change="getResults">
                <option value="Turnover">Turnover</option>
                <option value="Quantity">Quantity</option>
                <option value="Number of orders">Number of orders</option>
                <option value="Average order amount">Average order amount</option>
            </select>
            <div>Date range</div>
            <div class="row mb-3">
                <div class="col-6">
                    <input type="date" class="form-control" v-model="dateStart" @input="getResults">
                </div>
                <div class="col-6">
                    <input type="date" class="form-control" v-model="dateEnd" @input="getResults">
                </div>
            </div>
            <div class="btn btn-secondary" @click="exportExcel"><i class="las la-download"></i> Export (.xls)</div>
        </div>
    </div>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
);

export default {
    name: "LineChart",
    components: { LineChartGenerator },
    props: ['dataProducts', 'dataCategories', 'dataLocations'],
    data() {
        return {
            config: window.config,
            location_list: window.location_list,
            loaded: false,
            dataType: 'Turnover',
            dateStart: '',
            dateEnd: '',
            step: 'month',
            dataFilterType: 'global',
            dataSelectedProducts: [],
            dataSelectedCategories: [],
            dataSelectedLocations: [],
            chartData: null,
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
            }
        }
    },
    mounted() {
        this.getResults()
    },
    methods: {
        changeDataFilters() {
            this.dataSelectedProducts = this.dataSelectedCategories = this.dataSelectedLocations = []
            if (this.dataFilterType == 'global') {
                this.getResults()
            }
        },
        params(action) {
            return {
                action: action,
                dataProducts: this.dataSelectedProducts,
                dataCategories: this.dataSelectedCategories,
                dataLocations: this.dataSelectedLocations,
                dataType: this.dataType,
                dateStart: this.dateStart,
                dateEnd: this.dateEnd,
                step: this.step
            }
        },
        async getResults() {
            if (this.dataSelectedProducts.find((value) => value == 'all')) {
                this.dataSelectedProducts = ['all']
            }
            if (this.dataSelectedCategories.find((value) => value == 'all')) {
                this.dataSelectedCategories = ['all']
            }
            if (this.dataSelectedLocations.find((value) => value == 'all')) {
                this.dataSelectedLocations = ['all']
            }
            axios.post("/admin/ajax/statistics", this.params('chart'))
            .catch((error) => {
                new Noty({
                    type: "error",
                    text: "Operation failed",
                }).show();
            })
            .then((response) => {
                this.loaded = true
                this.chartData = response.data;
            });
        },
        exportExcel() {
            window.open('/admin/statistics/export?'+this.convertToQueryUrl(this.params('export')), '_blank')
        },
    }
};
</script>
